import Navigation from './src/main'

Navigation.install = function (Vue) {
    Vue.components(Navigation.name, Navigation)
}

export default Navigation